import { render, staticRenderFns } from "./PresentationPlayDemo.vue?vue&type=template&id=0ed7d804&scoped=true"
import script from "./PresentationPlayDemo.vue?vue&type=script&lang=js"
export * from "./PresentationPlayDemo.vue?vue&type=script&lang=js"
import style0 from "./PresentationPlayDemo.vue?vue&type=style&index=0&id=0ed7d804&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ed7d804",
  null
  
)

export default component.exports